import { useSelector } from 'react-redux';
import { get } from 'lodash';
import { saveState } from 'new/state/hashedState/action';
import useAppDispatch from 'js/hooks/useAppDispatch';

/**
 * @description Use this hook if you want to update an internal state in redux. It's basically an object that you can write any value (recommendation for primitive only) in any path and every time it is updated, it also updates a query parameter with the state hashed.
 * @param path - The path where the value will be saved/retrived
 * @return an object containing the data and a save method
 */

export function useHashedState(path: string) {
  const dispatch = useAppDispatch();
  const data = useSelector((state: any) => get(state.hashedState.data, path));

  function save(value: any) {
    return dispatch(saveState(path, value));
  }

  return {
    data,
    save,
  };
}
